<div class="pane-mini" *ngIf="!pane else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <ng-template [ngIf]="!pane?.infinity" [ngIfElse]="infinity">
      <div class="library-block">
        <div *ngIf="isDebug$ | async" class="debug">card-universal - mini card len: {{content.length}}</div>
        <div class="library-block" [ngClass]="pane.format">
          <app-content-drag-scroll
            [items]="content"
            [libraryTitle]="blockTitle"
            [pane]="pane"
            [isLibrary]="true">
          </app-content-drag-scroll>
        </div>
      </div>
  </ng-template>

  <ng-template #infinity>
    <div *ngIf="!pane.ignore_page_filters" class="pane-header" [class.mobile]="deviceService.isMobile()">
    <app-library-title *ngIf="blockTitle?.subtitle" [title]="blockTitle" [class.with-sorting]="_pane.show_sorting">
      <ng-container side>
        <span class="subtitle normal">{{ blockTitle?.subtitle | customLocale }}</span>
      </ng-container>
    </app-library-title>
    <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
    </div>

    <div class="infinity-content-cards">
      <div *ngFor="let item of content; let i = index; trackBy: trackByFn" class="infinity-item" (click)="onOpenCard(item)">
        <app-content-card-mini
          [item]="item"
          [linkEnable]="false"
          [format]="infinityFormat"
          [infinity]="pane?.infinity">
        </app-content-card-mini>
      </div>
    </div>

    <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
    <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>
  </ng-template>
</ng-template>

<app-modal *ngIf="!isSmallScreen && showModal"
           [canClose]="false"
           (closed)="onCloseModal($event)">
  <app-modal-body>
    <app-content-card
      class="modal"
      [item_id]="item.id"
      [show]="true"
      [canClose]="false"
      [inline]="false"
      [active]="false"
      [meta]="true">
    </app-content-card>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="isSmallScreen && showModal" (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <div class="card">
      <app-content-card
        [item_id]="item.id"
        [canClose]="false"
        [inline]="false"
        [active]="false"
        [displayMode]="'content_page'"
        [meta]="true">
      </app-content-card>
    </div>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
